import React, { Component } from 'react';
import { confirmDialog } from 'primereact/confirmdialog';

import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelTextArea } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import { buildRelacionados } from '../../../service/RotasService';

import Pesquisa                    from '../../../models/Pesquisa';
import PesquisaTipoEnum            from '../../../enums/PesquisaTipoEnum';
import PesquisaTipoEnvioEnum       from '../../../enums/PesquisaTipoEnvioEnum';
import PesquisaCondicaoDisparoEnum from '../../../enums/PesquisaCondicaoDisparoEnum';
import UsuarioEventoTipoEventoEnum from '../../../enums/UsuarioEventoTipoEventoEnum';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    id:   { exibir: 'main.id', tipo: 'numeric', largura: '5rem', fixar: true },
    nome: { exibir: 'main.pesquisa.nome', visivel: true, fixar: true },
    tipo: {
        exibir:   'main.pesquisa.tipo',
        visivel:  true,
        tipo:     'enum',
        entidade: 'pesquisa.tipo',
        largura: "8rem",
    },
    tipoenvio: {
        exibir:   'main.pesquisa.tipoenvio',
        visivel:  true,
        tipo:     'enum',
        entidade: 'pesquisa.tipoenvio',
        largura: "8rem",
    },
    eventogatilho: {
        exibir:   'main.pesquisa.eventogatilho',
        visivel:  true,
        tipo:     'enum',
        entidade: 'usuarioevento.tipoevento',
    },
    condicaodisparo: {
        exibir:   'main.pesquisa.condicaodisparo',
        visivel:  true,
        tipo:     'enum',
        entidade: 'pesquisa.condicaodisparo',
    },
    ativa: {
        exibir:   'main.pesquisa.ativa',
        visivel:  true,
        tipo:     'boolean',
        template: 'ativa.template',
        fixar: true,
        largura: "4rem"
    },
    dataultimaexecucao: { exibir: 'main.pesquisa.dataultimaexecucao', visivel: true, largura: '12rem', tipo: 'date', time: true },
    // Ocultos na grid por padrao (disponiveis no configurador) - conteudo longo/tecnico, mesmo
    // tratamento de campos como UsuarioTransacao.ultimoretorno.
    mensagem: { exibir: 'main.pesquisa.mensagem', hidegrid: true },
    assunto: { exibir: 'main.pesquisa.assunto', hidegrid: true },
    // id/updatedAt/createdAt sao injetados automaticamente pelo EntityGrid (mesclarCamposPadrao).
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const booleanTemplate = (campo) => (rowData) => (
    <i className={`pi ${rowData[campo] ? 'pi-check text-green-500' : 'pi-times text-red-400'}`}></i>
);

const renderers = {
    ativa:                          { template: booleanTemplate('ativa') },
    'pesquisa.tipo':                PesquisaTipoEnum,
    'pesquisa.tipoenvio':           PesquisaTipoEnvioEnum,
    'pesquisa.condicaodisparo':     PesquisaCondicaoDisparoEnum,
    'usuarioevento.tipoevento':     UsuarioEventoTipoEventoEnum,
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

// nome/tipo/tipoenvio/eventogatilho/condicaodisparo/mensagem/assunto/ativa sao editaveis pelo
// admin (ao contrario de TarefaAgendadaFormulario, aqui o conteudo da pesquisa E' o que o admin
// configura). Ativa tambem pode ser alternada aqui direto, alem do processo de toolbar
// Ativar/Desativar (ver processos() abaixo) - os dois caminhos passam por Pesquisa.beforeUpdate no
// backend, que reseta dataultimaexecucao ao detectar a transicao false->true, entao nao ha
// divergencia de comportamento entre editar o campo ou usar o botao. dataultimaexecucao continua
// somente leitura (sempre gerido pelo sistema). Sem campo de cron proprio - o envio e' verificado
// de hora em hora por uma unica TarefaAgendada compartilhada ("Pesquisa.executarPendentes"), que
// varre todas as Pesquisa ativas.
class PesquisaFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <div className="grid">
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={model.nome} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={model.assunto} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.tipo} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.tipoenvio} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.eventogatilho} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.condicaodisparo} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelBoolean model={model.ativa} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelCalendar model={{ ...model.dataultimaexecucao, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 mt-3">
                    <ModelTextArea model={model.mensagem} contexto={contexto} rows={4} />
                </div>
            </div>
        );
    }
}

// ─── Template (componente exportado) ──────────────────────────────────────────

class PesquisaTemplate extends Component {

    processos() {
        const { permissoes } = this.props;
        const t = (chave) => UtilService.traduzir(chave);
        const lista = [];

        const podeAtivar = permissoes?.pesquisa?.processos?.some(
            (e) => e.state === 'main.pesquisa.ativar' && e.permitido,
        );
        const podeDesativar = permissoes?.pesquisa?.processos?.some(
            (e) => e.state === 'main.pesquisa.desativar' && e.permitido,
        );
        if (podeAtivar || podeDesativar) {
            lista.push({
                label: 'main.pesquisa.ativar',
                icon:  'pi pi-power-off',
                disabled: true,
                ativo: (processo, selected) => {
                    const row = selected?.[0];
                    processo.disabled = selected.length !== 1;
                    if (row?.ativa) {
                        processo.label = 'main.pesquisa.desativar';
                        processo.icon = 'pi pi-power-off text-red-500';
                    } else {
                        processo.label = 'main.pesquisa.ativar';
                        processo.icon = 'pi pi-power-off text-green-500';
                    }
                    return processo;
                },
                command: () => {
                    const row = this.gridRef?.getSelected()?.[0];
                    if (!row) return;
                    const ativando = !row.ativa;
                    const acao = ativando ? 'ativar' : 'desativar';
                    confirmDialog({
                        header:       t(`main.pesquisa.${acao}.confirmacao.header`),
                        message:      t(`main.pesquisa.${acao}.confirmacao.mensagem`),
                        icon:         'pi pi-exclamation-triangle',
                        className:    'w-4',
                        draggable:    false,
                        defaultFocus: 'reject',
                        acceptClassName: ativando ? 'p-button-success' : 'p-button-danger',
                        accept: async () => {
                            try {
                                await (ativando ? Pesquisa.ativar(row.id) : Pesquisa.desativar(row.id));
                                UtilService.showToast({ severity: 'success', summary: t(`main.pesquisa.${acao}.sucesso`) });
                            } catch {
                                UtilService.showToast({ severity: 'error', summary: t(`main.pesquisa.${acao}.erro`) });
                            }
                            await this.gridRef?.atualizar();
                        },
                    });
                },
            });
        }

        const podeExecutarAgora = permissoes?.pesquisa?.processos?.some(
            (e) => e.state === 'main.pesquisa.executaragora' && e.permitido,
        );
        if (podeExecutarAgora) {
            lista.push({
                label:    'main.pesquisa.executaragora',
                icon:     'pi pi-play',
                disabled: true,
                ativo: (processo, selected) => {
                    processo.disabled = selected.length !== 1;
                    return processo;
                },
                command: () => {
                    const row = this.gridRef?.getSelected()?.[0];
                    if (!row) return;
                    confirmDialog({
                        header:       t('main.pesquisa.executaragora.confirmacao.header'),
                        message:      t('main.pesquisa.executaragora.confirmacao.mensagem'),
                        icon:         'pi pi-exclamation-triangle',
                        className:    'w-4',
                        draggable:    false,
                        defaultFocus: 'reject',
                        acceptClassName: 'p-button-warning',
                        accept: async () => {
                            try {
                                const resultado = await Pesquisa.executarAgora(row.id);
                                if (resultado?.status && resultado.data?.status) {
                                    UtilService.showToast({ severity: 'success', summary: t('main.pesquisa.executaragora.sucesso') });
                                } else {
                                    UtilService.showToast({ severity: 'error', summary: t('main.pesquisa.executaragora.erro'), detail: resultado?.data?.mensagem });
                                }
                            } catch {
                                UtilService.showToast({ severity: 'error', summary: t('main.pesquisa.executaragora.erro') });
                            }
                            await this.gridRef?.atualizar();
                        },
                    });
                },
            });
        }

        return lista;
    }

    render() {
        return (
            <EntityGrid
                ref={(ref) => this.gridRef = ref}
                entidade={Pesquisa}
                model={model}
                identidade="main.pesquisa"
                permissoes={this.props.permissoes}
                icone="pi-comment"
                storageKey="dt-pesquisas"
                processos={this.processos()}
                getRelacionados={(selected) => buildRelacionados(
                    'pesquisa',
                    this.props.permissoes,
                    this.props.navigate,
                    () => selected?.[0],
                )}
                renderers={renderers}
                configuracao={this.props.configuracao}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                ordenacaoPadrao={{ sortField: 'nome', sortOrder: 1 }}
                formulario={(m, ctx) => <PesquisaFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default PesquisaTemplate;
